import { FC, PropsWithChildren } from "react";

import { cn } from "@/ui/lib";
import { TAlertAssetProps } from "./Alert.config";
import { isAlertAssetImage } from "./Alert.guards";

export const AlertAssetWrapper: FC<PropsWithChildren<TAlertAssetProps>> = ({ asset, children }) => (
  <>
    { children ? (
      <div
        className={cn(
          "col-start-1 row-start-1",
          (asset && isAlertAssetImage(asset)) ? "row-span-2 self-stretch" : "self-center",
        )}
      >
        { children }
      </div>
    ) : null }
  </>
);
